<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-th-list"></i>
        WFDetector - WMDS
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WFDetector</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Detect</a>
          </li>
      </ul>
    </div>
    <b-card>
        <b-row>
          <b-col sm="6">
            위변조 대상 도메인 설정이 필요해요
          </b-col>
          <hr>
          <b-col sm="6">
            <b-input-group size="sm">
              <b-input-group-prepend>
                <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
                <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
                <b-dropdown :text="so.skt || '검색'" :value="so.sk='fqdn'"  size="sm" variant="outline-secondary">
                  <b-dropdown-item size="sm" @click="so.sk='fqdn'; so.skt='FQDN'">FQDN</b-dropdown-item>
                  <b-dropdown-item size="sm" @click="so.sk='name'; so.skt='이름'">이름</b-dropdown-item>
                </b-dropdown>
              </b-input-group-prepend>
              <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
              <b-input-group-append>
                <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <hr>
        <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="자료가 없습니다." class="text-center table-responsive table_add"
          :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
          <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
          <template slot="name" slot-scope="row">
            <del v-if="row.item.is_del">{{row.item.name}}</del>
            <template v-else>{{row.item.name}}</template>
          </template>
          <template slot="fqdn" slot-scope="row">{{row.item.fqdn}}</template>
          <template slot="last_visit" slot-scope="row">{{row.item.last_visit | sdate}}</template>
          <template slot="updated_at" slot-scope="row">{{row.item.updated_at | sdate}}</template>
          <template slot="func" slot-scope="row">
            <!-- <b-btn @click="result_select(row.item)" size="sm" variant="outline-primary">Select</b-btn> -->
            <b-button :variant="(row.item.last_visit ? (model && model.id == row.item.id ? 'danger' : 'primary') : 'secondary')" size="sm" @click="result_select(row.item)" :disabled="!row.item.last_visit">
            {{(model && model.id == row.item.id ? '선택함' : '선택')}}
          </b-button>
          </template>
        </b-table>

        <b-row>
          <b-col class="md-6">
            <b-pagination size="sm"  align="center" :limit="10" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
          </b-col>
        </b-row>
      </b-card>

      <b-card v-if="model && model.id">
      <b-row>
        <b-col>
          <span class="float-left">설치일 : {{model.created_at | datetime }}</span>
        </b-col>
        <b-col>
          <span class="float-left">FQDN : {{model.fqdn }}</span>
        </b-col>
        <b-col>
          <span class="float-left" v-b-tooltip.hover title="Can change Enable, if setting complete, auth change Yes" cusor="pointer" style="cursor:pointer">
            상태 :
            <b-badge @click="scan_status(false)" variant="success" v-if="model.is_alive">사용</b-badge>
            <b-badge @click="scan_status(true)" v-else>사용안함</b-badge>
          </span>
        </b-col>
        <b-col>
          <b-button class="float-right" variant="outline-primary" size="sm" @click="detail()">관리</b-button>
          <b-button class="float-right" variant="outline-warning" size="sm" @click="clear()">지우기</b-button>
        </b-col>
      </b-row>
    </b-card>

      <b-card :class="!snapshot.length ? 'bg-secondary text-black text-center' : 'text-center'">
        <p>
          <span class="float-left">Last updated : {{model.last_updated | datetime }}</span>
          <span>정책 설정 ({{snapshot.length || 0}})</span> - <span>드래그 & 드롭 (저장 버튼 클릭)</span>
          <b-button v-if="snapshot.length" class="pull-right" variant="warning" @click="clear_forgery()">초기화</b-button>
        </p>
        <!-- <span v-if="model && model.id" class="mr-3">* Set HTML elements depth level </span> -->
        <!-- <span v-if="model && model.id" class="mr-3">* Set URL </span> -->
        <div v-if="model && model.id">
          <b-button v-if="model && model.id" block href="#" variant="success" @click="save">
            저장
          </b-button>
        </div>
        <hr>
        <span v-if="model && model.id" class="float-left">* 기본적으로 10페이지를 설정할 수 있습니다. 주로 변경의 영향을 많이 받는 메인페이지를 설정합니다.</span>
        <br>
        <hr>
        <draggable tag="ul" :list="snapshot" class="list-group" handle=".handle" group="people" :options="{ disabled : snapshot.length >= 10}" >
          <li class="list-group-item" v-for="(i, idx) in snapshot" :key="idx" >
            <i class="fa fa-times close" @click="remove(idx)"></i>
            <p class="handle" style="cursor:pointer; float:left">
              <!-- <i class="fa fa-delicious"></i> -->
              <!-- <span class="text">Level : {{ Number(i.dept) + 1 }} </span>
              / -->
              <span class="text" style="padding-left:10px">{{ i.url }} </span>

              <!-- <b-form-radio-group inline v-model="i.dept">
                <b-form-radio value='0'>1</b-form-radio>
                <b-form-radio value='1'>2</b-form-radio>
                <b-form-radio value='2'>3</b-form-radio>
                <b-form-radio value='3'>4</b-form-radio>
                <b-form-radio value='4'>5</b-form-radio>
                <b-form-radio value='9'>Max_Depth</b-form-radio> -->
                <!-- <span class="text">{{ i.hash }} </span> -->
              <!-- </b-form-radio-group> -->
            </p>
          </li>
        </draggable>
      </b-card>

      <b-card :class="request ? 'bg-secondary text-black' : ''">
        <div v-if="request && page && page.list && page.list.length">
          <span class="folat-left">모니터링 타겟 URL</span>
          <span class="folat-left">전체 : {{model.page_count}} / 페이지 : 1 ~ {{page.end}}</span>
          <span class="float-right" v-if="model.page_count > page.end">스크롤으로 더많은 내용 확인가능</span>
        </div>
        <div v-else class="text-center">
          <span v-if="request">
            <i :class="`fa fa-refresh fa-spin`"></i>
            로딩중...
          </span>
          <span v-if="page.list.length < 1">페이지 리스트가 없습니다.</span>
        </div>
        <hr>
        <div style="max-height: 600px; overflow: auto;"  @scroll="scroll_page" ref="page_list">
        <draggable class="list-group" :list="page.list" group="people">
          <div style="cursor:pointer" class="list-group-item" v-for="(i, index) in page.list" :key="index">
            {{ i.url }}
          </div>
        </draggable>
      </div>
      </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
